var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136 326h134V204H136v122zm14-110h108v96H150v-96z M210 284h-40c-4 0-8 4-8 8 0 2 4 6 8 6h40c4 0 6-4 6-6 0-4-2-8-6-8zM238 284h-8c-4 0-6 4-6 8 0 2 2 6 6 6h8c2 0 6-4 6-6 0-4-4-8-6-8zM238 230h-42c-4 0-6 4-6 8 0 2 2 6 6 6h42c2 0 6-4 6-6 0-4-4-8-6-8zM238 258h-14c-4 0-8 2-8 6s4 6 8 6h14c2 0 6-2 6-6s-4-6-6-6zM170 270h12c4 0 8-2 8-6s-4-6-8-6h-12c-4 0-8 2-8 6s4 6 8 6zM170 244h6c4 0 6-4 6-6 0-4-2-8-6-8h-6c-4 0-8 4-8 8 0 2 4 6 8 6zM208 268c2 0 2-2 2-4s0-4-2-4c-2-4-8-4-10 0 0 0-2 2-2 4s2 4 2 4c2 2 4 2 6 2 0 0 2 0 4-2z M336 0H70L0 114v292h406V114L336 0zm-8 14 60 94H250V14h78zm-124 0h34v94h-68V14h34zm-34 108h6c0 4 4 6 6 6 4 0 8-2 8-6h26c0 4 4 6 8 6s6-2 6-6h8v24l-8-6-26 26-28-26-6 6v-24zM78 14h78v94H18l60-94zm92 378v-16l6 6 28-26 26 26 8-6v16h-68zm80 0v-50l-20 20-26-26-28 26-20-20v50H14V122h142v56l20-20 28 28 26-28 20 20v-56h142v270H250z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 20,
    r: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 182,
    cy: 40,
    r: 6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 182,
    cy: 82,
    r: 6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 60,
    r: 6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 40,
    r: 6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 82,
    r: 6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 102,
    r: 6
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 142,
    r: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/Orders.26d562810cf24c46d12dbd65b9242742.svg";
export { ForwardRef as ReactComponent };